import * as React from "react";

import {
  AppFontStylesFullGallery,
  AppFontStylesFullGalleryProps,
} from "@1js/acui-gallery-font-styles";

import { RibbonControlInternalProps } from "../../RibbonControlProps";

export class RibbonFontStylesFullGallery extends React.PureComponent<
  AppFontStylesFullGalleryProps & RibbonControlInternalProps,
  {}
> {
  public render() {
    return <AppFontStylesFullGallery {...this.props} />;
  }
}
